'use client';
import { objectValues, objectKeys } from '@s7/utils';
import { transformExtendedQuery } from '../../../modules/responsive/syntaxExtensions/transformExtendedQuery.js';

const responsive = (theme)=>(breakpoints)=>(injector)=>{
            if (!breakpoints || !objectValues(breakpoints).length) {
                return undefined;
            }
            return objectKeys(breakpoints).reduce((target, query)=>{
                const params = breakpoints[query];
                if (params) {
                    var _transformExtendedQuery;
                    const selector = query.startsWith('@media') ? query : (_transformExtendedQuery = transformExtendedQuery(query, 'em')(theme)) != null ? _transformExtendedQuery : theme.fn.up(query, 'em');
                    target[selector] = injector(params);
                }
                return target;
            }, {});
        };

export { responsive };
//# sourceMappingURL=responsive.js.map
